import { render } from "./DigitalInterval.vue?vue&type=template&id=6b314380&scoped=true"
import script from "./DigitalInterval.vue?vue&type=script&lang=js"
export * from "./DigitalInterval.vue?vue&type=script&lang=js"

import "./DigitalInterval.vue?vue&type=style&index=0&id=6b314380&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b314380"]])

export default __exports__